import { render, staticRenderFns } from "./TreatmentRequestWrapper.vue?vue&type=template&id=65516061&scoped=true&"
import script from "./TreatmentRequestWrapper.vue?vue&type=script&lang=ts&"
export * from "./TreatmentRequestWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65516061",
  null
  
)

export default component.exports